import { apiRequest, buildQuery } from "./api-client";

export const supportService = {
    myTickets() {
        return apiRequest("/me/support-tickets");
    },
    createTicket(payload) {
        return apiRequest("/me/support-tickets", { method: "POST", body: payload });
    },
    replyToTicket(ticketId, message) {
        return apiRequest(`/me/support-tickets/${ticketId}/messages`, { method: "POST", body: { message } });
    },
    adminTickets(params = {}) {
        return apiRequest(`/admin/support-tickets${buildQuery(params)}`);
    },
    adminUpdateTicket(ticketId, payload) {
        return apiRequest(`/admin/support-tickets/${ticketId}`, { method: "PATCH", body: payload });
    }
};
